import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Message } from 'primeng/api';
import { EntradaEstoque } from 'src/app/admihair/api/dto/entrada-estoque';
import { EntradaProduto } from 'src/app/admihair/api/dto/entrada-produto';
import { EntradaEstoqueService } from 'src/app/admihair/service/entrada-estoque.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';

@Component({
  selector: 'app-entrada-detalhar',
  templateUrl: './entrada-detalhar.component.html',
  styleUrls: ['./entrada-detalhar.component.scss']
})
export class EntradaDetalharComponent implements OnInit {

  permissaoDetalhar: boolean = false;
  messages: Message[] = [];
  messagemVisivel: boolean = false;
  id?: number;
  entradaEstoque?: EntradaEstoque;
  listaEntradaProduto: EntradaProduto[] = [];
  loading: boolean = true;
  @ViewChild('f') form?: NgForm;

  constructor(private entradaEstoqueService: EntradaEstoqueService,
    private activatedRouter: ActivatedRoute,
    private erroService: ErroService) { }


  ngOnInit(): void {
    this.permissaoDetalhar = this.verificarPermissao('PERM_DETALHAR_ENTRADA');
    this.carregarIdEntrada();
    if (this.permissaoDetalhar) {
      this.carregarEntradaEstoque();
    }

  }

  carregarEntradaEstoque() {
    this.entradaEstoqueService.buscarPorId(this.id).subscribe({
      next: (data: EntradaEstoque) => {
        this.entradaEstoque = data;
        if (this.entradaEstoque.listaEntradaProduto) {
          this.listaEntradaProduto = this.entradaEstoque.listaEntradaProduto;
        }
        this.loading = false;
      },
      error: (err: any) => {
        this.loading = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
      }
    });
  }

  verificarPermissao(nome: string): boolean {
    return AuthUtil.verificarPermissao(nome);
  }

  carregarIdEntrada() {
    const idParam = this.activatedRouter.snapshot.paramMap.get('id');
    if (idParam) {
      this.id = parseInt(idParam);
    }
  }
}
